import script from "./WageProcess.vue?vue&type=script&setup=true&lang=ts"
export * from "./WageProcess.vue?vue&type=script&setup=true&lang=ts"

import "./WageProcess.vue?vue&type=style&index=0&id=1b2a11bf&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b2a11bf"]])

export default __exports__